function preload(overlay, body, style) {
	function ready() {
		document.querySelector(body).removeAttribute(style);
		document.querySelector(overlay).remove();
	}
	window.addEventListener("load", ready);
}

export default preload;
